(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fighters-video-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const SELECTOR = 'video[data-fc-hero-video]';

    const conn = navigator.connection || {};
    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const saveData = conn.saveData === true;
    const slowNetwork = /(^|-)2g$/.test(conn.effectiveType || '');

    // Poster-only visitors: never touch the network for the video.
    const posterOnly = prefersReduced || saveData || slowNetwork;

    function attach(video) {
      if (video.dataset.fcHeroLoaded) return;
      video.dataset.fcHeroLoaded = '1';

      const mobile = video.dataset.srcMobile;
      const desktop = video.dataset.srcDesktop;
      const useMobile = window.matchMedia('(max-width: 749px)').matches && mobile;
      const src = useMobile ? mobile : desktop || mobile;
      if (!src) return;

      const reveal = () => video.classList.add('is-playing');
      video.addEventListener('playing', reveal, { once: true });
      video.addEventListener('loadeddata', reveal, { once: true });

      video.preload = 'auto';
      video.src = src;

      const played = video.play();
      if (played && typeof played.catch === 'function') {
        // Autoplay refused (battery saver, iOS low power). Poster stays; no error.
        played.catch(() => {});
      }
    }

    function start() {
      document.querySelectorAll(SELECTOR).forEach((video) => {
        if (posterOnly) return;

        if (!('IntersectionObserver' in window)) {
          attach(video);
          return;
        }

        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              observer.disconnect();
              attach(video);
            });
          },
          { rootMargin: '200px' }
        );
        observer.observe(video);
      });
    }

    // Wait for load, then for an idle moment, so the video never competes
    // with LCP, fonts or the critical CSS.
    function schedule() {
      if ('requestIdleCallback' in window) {
        requestIdleCallback(start, { timeout: 2500 });
      } else {
        setTimeout(start, 1200);
      }
    }

    if (document.readyState === 'complete') {
      schedule();
    } else {
      window.addEventListener('load', schedule, { once: true });
    }

    // Theme editor: re-run when the section is re-rendered.
    document.addEventListener('shopify:section:load', (event) => {
      if (event.target.querySelector(SELECTOR)) start();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
  (() => {
    const slugify = (value) =>
      value
        .toLowerCase()
        .trim()
        .replace(/['’]/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');

    const replaceBodyHeadings = (body) => {
      body.querySelectorAll('h1').forEach((heading) => {
        const replacement = document.createElement('h2');
        [...heading.attributes].forEach((attribute) => {
          replacement.setAttribute(attribute.name, attribute.value);
        });
        while (heading.firstChild) replacement.appendChild(heading.firstChild);
        heading.replaceWith(replacement);
      });
    };

    const removeLegacyPresentation = (root, body) => {
      body.querySelectorAll('style').forEach((style) => style.remove());
      body.querySelectorAll('[style]').forEach((element) => element.removeAttribute('style'));
      body.querySelectorAll('nav.fc-toc').forEach((toc) => {
        toc.hidden = true;
        toc.setAttribute('aria-hidden', 'true');
      });

      if (root.classList.contains('fc-article--category')) {
        body
          .querySelectorAll('a[href="/blogs/fighters-guide/the-ultimate-guide-to-boxing-training-for-beginner"]')
          .forEach((link) => {
            const legacyReturn = link.closest('.badge');
            if (!legacyReturn) return;
            legacyReturn.hidden = true;
            legacyReturn.setAttribute('aria-hidden', 'true');
          });
      }
      replaceBodyHeadings(body);

      if (root.dataset.fcHasFeaturedImage === 'true') {
        const leadImage = body.querySelector('img');
        if (leadImage) {
          leadImage.dataset.fcLeadImage = 'true';
          leadImage.hidden = true;
          leadImage.setAttribute('aria-hidden', 'true');
        }
      }
    };

    const wrapTables = (body) => {
      body.querySelectorAll('table').forEach((table) => {
        table.classList.add('fc-article__table--responsive');
        const headerCells = [...table.querySelectorAll('thead tr:first-child > th, thead tr:first-child > td')];
        const headers = headerCells.map((cell) => cell.textContent.trim());
        [...table.tBodies].forEach((tbody) => {
          [...tbody.rows].forEach((row) => {
            [...row.cells].forEach((cell, index) => {
              cell.dataset.fcTableLabel = headers[index] || '';
            });
          });
        });

        let wrapper = table.parentElement;
        if (!wrapper?.classList.contains('fc-article__table-scroll')) {
          wrapper = document.createElement('div');
          wrapper.className = 'fc-article__table-scroll';
          table.before(wrapper);
          wrapper.appendChild(table);
        }
        wrapper.setAttribute('role', 'region');
        wrapper.setAttribute('tabindex', '0');
      });
    };

    const normalizeReviewContent = (root, body) => {
      const cards = [...body.querySelectorAll('.fc-card')].filter((card) =>
        card.querySelector('.fc-product-img')
      );
      const affiliateLink = body.querySelector('.fc-btn.amazon, a[rel~="sponsored"]');
      if (cards.length < 2 || !affiliateLink) return;

      root.classList.add('fc-article--review');
      const hideLegacyBuyBars = () => {
        document.querySelectorAll('#fcStickyBar, .fcsb').forEach((bar) => {
          bar.hidden = true;
          bar.setAttribute('aria-hidden', 'true');
        });
      };
      hideLegacyBuyBars();
      window.setTimeout(hideLegacyBuyBars, 800);
      window.setTimeout(hideLegacyBuyBars, 3000);

      cards.forEach((card) => {
        card.classList.add('fc-review-card');
        if (card.querySelector(':scope > .fc-review-card__intro')) return;

        const directChildren = [...card.children];
        const mediaSource = directChildren.find((element) =>
          element.matches('.fc-media, img.fc-product-img')
        );
        const rank = directChildren.find((element) => element.classList.contains('fc-rank'));
        const badge = directChildren.find((element) => element.classList.contains('fc-badge'));
        const title = directChildren.find((element) => element.matches('h3, h4'));
        const rating = directChildren.find((element) => element.classList.contains('fc-rating'));
        const lead = directChildren.find((element) => element.matches('p'));
        const intro = document.createElement('div');
        const summary = document.createElement('div');

        intro.className = 'fc-review-card__intro';
        summary.className = 'fc-review-card__summary';

        if (mediaSource) {
          let media = mediaSource;
          if (mediaSource.matches('img')) {
            media = document.createElement('div');
            media.appendChild(mediaSource);
          }
          media.classList.add('fc-review-card__media');
          intro.appendChild(media);
        } else {
          card.classList.add('fc-review-card--no-media');
        }

        [rank, badge, title, rating, lead].forEach((element) => {
          if (element) summary.appendChild(element);
        });
        intro.appendChild(summary);
        card.prepend(intro);

        const affiliateCta = card.querySelector(':scope > .fc-btn.amazon, :scope > a[rel~="sponsored"]');
        if (affiliateCta && !affiliateCta.closest('.fc-review-card__action')) {
          const action = document.createElement('div');
          const note = document.createElement('p');
          action.className = 'fc-review-card__action';
          note.className = 'fc-review-card__affiliate-note';
          note.textContent = 'Amazon affiliate link · Price and availability may vary.';
          affiliateCta.before(action);
          action.appendChild(affiliateCta);
          action.appendChild(note);
        }
      });

      const classifyImage = (image) => {
        const update = (allowHide = false) => {
          const available = image.naturalWidth > 24 && image.naturalHeight > 24;
          const card = image.closest('.fc-review-card');
          const quickPick = image.closest('.fc-qp');
          const media = image.closest('.fc-review-card__media');
          if (available) {
            image.hidden = false;
            image.removeAttribute('aria-hidden');
            card?.classList.remove('fc-review-card--no-media');
            quickPick?.classList.remove('fc-qp--no-media');
            if (media) media.hidden = false;
            return;
          }

          if (!allowHide) return;
          image.hidden = true;
          image.setAttribute('aria-hidden', 'true');
          card?.classList.add('fc-review-card--no-media');
          quickPick?.classList.add('fc-qp--no-media');
          if (media) media.hidden = true;
        };

        if (image.complete) {
          update(true);
        } else {
          image.addEventListener('load', update, { once: true });
          image.addEventListener('error', () => update(true), { once: true });
          if ('IntersectionObserver' in window) {
            const observer = new IntersectionObserver((entries) => {
              if (!entries.some((entry) => entry.isIntersecting)) return;
              observer.disconnect();
              window.setTimeout(() => update(true), 2500);
            }, { rootMargin: '320px 0px' });
            observer.observe(image);
          } else {
            const rect = image.getBoundingClientRect();
            const isNearViewport = rect.top < window.innerHeight + 500 && rect.bottom > -500;
            if (isNearViewport) window.setTimeout(() => update(true), 2500);
          }
        }
      };

      body.querySelectorAll('.fc-review-card .fc-product-img, .fc-qp img').forEach(classifyImage);
    };

    const buildToc = (root, body) => {
      const desktop = root.querySelector('[data-fc-toc]');
      const desktopList = root.querySelector('[data-fc-toc-list]');
      const mobile = root.querySelector('[data-fc-mobile-toc]');
      const mobileList = root.querySelector('[data-fc-mobile-toc-list]');
      if (!desktopList || !mobileList) return;

      const tocTitle = root.querySelector('.fc-article__mobile-toc-title')?.textContent.trim().toLowerCase();
      const headings = [...body.querySelectorAll('h2')].filter((heading) => {
        const text = heading.textContent.trim();
        const isLegacyNavigation = heading.closest('nav.fc-toc, [hidden]');
        const isClosingCallout = heading.closest('.cta-section, .fc-footer, .article-cta, .fc-final');
        return text && !isLegacyNavigation && !isClosingCallout && text.toLowerCase() !== tocTitle;
      });
      if (headings.length < 2) return;

      const ids = new Set();
      const links = [];
      headings.forEach((heading, index) => {
        let id = heading.id || slugify(heading.textContent) || `section-${index + 1}`;
        let uniqueId = id;
        let suffix = 2;
        while (ids.has(uniqueId) || document.getElementById(uniqueId)) {
          if (heading.id === uniqueId) break;
          uniqueId = `${id}-${suffix}`;
          suffix += 1;
        }
        heading.id = uniqueId;
        ids.add(uniqueId);

        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${uniqueId}`;
        link.textContent = heading.textContent.trim();
        item.appendChild(link);
        desktopList.appendChild(item);
        links.push(link);

        const mobileItem = item.cloneNode(true);
        mobileList.appendChild(mobileItem);
      });

      desktop.hidden = false;
      mobile.hidden = false;
      root.classList.add('fc-article--generated-toc');

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(
          (entries) => {
            const visible = entries
              .filter((entry) => entry.isIntersecting)
              .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top)[0];
            if (!visible) return;
            links.forEach((link) => {
              if (link.hash === `#${visible.target.id}`) {
                link.setAttribute('aria-current', 'true');
              } else {
                link.removeAttribute('aria-current');
              }
            });
          },
          { rootMargin: '-18% 0px -68% 0px', threshold: 0 }
        );
        headings.forEach((heading) => observer.observe(heading));
      }
    };

    const updateReadingTime = (root, body) => {
      const target = root.querySelector('[data-fc-reading-time]');
      if (!target) return;
      const words = body.innerText.trim().split(/\s+/).filter(Boolean).length;
      target.textContent = Math.max(1, Math.ceil(words / 220));
    };

    const bindProgress = (root) => {
      if (root.dataset.fcShowProgress !== 'true') return;
      const bar = root.querySelector('[data-fc-progress]');
      if (!bar) return;
      let ticking = false;
      const update = () => {
        const rect = root.getBoundingClientRect();
        const total = Math.max(1, root.offsetHeight - window.innerHeight);
        const traveled = Math.min(total, Math.max(0, -rect.top));
        bar.style.transform = `scaleX(${traveled / total})`;
        ticking = false;
      };
      const requestUpdate = () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
      };
      update();
      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', requestUpdate);
    };

    const bindMotion = (root, body) => {
      if (root.dataset.fcEnableMotion !== 'true') return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const elements = body.querySelectorAll(
        'h2, blockquote, figure, .quick-answer, .fc-answer-card, .qa, .warn, .pro-tip, .section-card, .stats-grid'
      );
      elements.forEach((element) => element.classList.add('fc-reveal'));
      if (!('IntersectionObserver' in window)) {
        elements.forEach((element) => element.classList.add('is-visible'));
        return;
      }
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
      );
      elements.forEach((element) => observer.observe(element));
    };

    const bindShare = (root) => {
      const button = root.querySelector('[data-fc-share]');
      if (!button) return;
      button.addEventListener('click', async () => {
        try {
          const shareData = {
            title: button.dataset.fcShareTitle,
            url: button.dataset.fcShareUrl
          };
          if (navigator.share) {
            await navigator.share(shareData);
            return;
          }
          await navigator.clipboard.writeText(shareData.url);
        } catch (error) {
          if (error?.name !== 'AbortError') button.focus();
        }
      });
    };

    const init = (root) => {
      if (root.dataset.fcReady === 'true') return;
      const body = root.querySelector('[data-fc-article-body]');
      if (!body) return;
      root.dataset.fcReady = 'true';
      removeLegacyPresentation(root, body);
      wrapTables(body);
      normalizeReviewContent(root, body);
      buildToc(root, body);
      updateReadingTime(root, body);
      bindProgress(root);
      bindMotion(root, body);
      bindShare(root);
    };

    const initAll = (scope = document) => {
      scope.querySelectorAll('[data-fc-article]').forEach(init);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
